import { TableColumn } from '@/typing';
import { getDate, getDateTime, getTime2 } from '@/utils/function';

export default (current_org: any) => {
  const None = null;
  const True = true;
  const False = false;
  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '创建时间',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      resizable: true,
      content: (record: any, text: any) => getDateTime(text),
    },
    {
      title: '等级',
      width: 150,
      dataIndex: 'level',
      checked: true,
      resizable: true,
      cellComponent: 'tag',
      content: (record: any, text: any) => {
        switch (text) {
          case 5:
            return '基础信息';
          case 10:
            return '调试';
          case 20:
            return '信息';
          case 25:
            return '数据成功';
          case 30:
            return '数据异常';
          case 40:
            return '逻辑错误';
          case 50:
            return '程序崩溃';
        }
      },
      color: (record: any, text: any) => {
        switch (text) {
          case 5:
            return 'cyan';
          case 10:
            return 'blue';
          case 20:
            return '#108ee9';
          case 25:
            return 'green';
          case 30:
            return 'orange';
          case 40:
            return 'red';
          case 50:
            return '#f50';
        }
      },

      filterMultiple: true,
      filters: [
        { text: '全部', value: '' },
        { text: '基础信息', value: '5' },
        { text: '调试', value: '10' },
        { text: '信息', value: '20' },
        { text: '数据成功', value: '25' },
        { text: '数据异常', value: '30' },
        { text: '逻辑错误', value: '40' },
        { text: '程序崩溃', value: '50' },
      ],
    },
    {
      title: '日志简注',
      width: 150,
      dataIndex: 'message',
      checked: true,
      resizable: true,
    },
    {
      title: '项目分类ID',
      width: 150,
      dataIndex: 'id',
      checked: false,
      resizable: true,
    },
    {
      title: '数据详情',
      width: 150,
      dataIndex: 'extra',
      checked: true,
      resizable: true,
      cellComponent: 'json_modal',
    },
    {
      title: '文件详情',
      width: 150,
      dataIndex: 'file_info',
      checked: true,
      resizable: true,
      cellComponent: 'json_modal',
    },
  ];

  return {
    baseColumns: baseColumns,
  };
};
